export default __webpack_public_path__ + "static/our-team-tablet-2-a7d12cf3c0e82194c8cadfbeaab992b2.png";